import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { svgIconList } from '@shared/svg-icon-list';
import { PromotionContentDataService } from '@pages/promotion/services/promotion-content-data.service';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class BonusListWebsocketService {
  svg: any = svgIconList;
  unsubscribeBonusList: (() => void) | null = null;
  bonusListChannelName: string | null = null;

  constructor(
    private promotionContentDataService: PromotionContentDataService,
    private translateService: TranslateService,
    private router: Router,
    // private socketIoService: SocketIoService
  ) { }

  listenGetBonusListEvent() {
    const userData = localStorage.getItem('user_data');

    this.bonusListChannelName = 'bo.bonus.update' + JSON.parse(userData).id;
    // this.unsubscribeBonusList = this.socketIoService.channel(this.bonusListChannelName).listen("GetBonusListEvent", (data) => { 
    //   this.promotionContentDataService.getPromotion().pipe(
    //     tap(res => {
    //       console.log(res);
    //       const bonusPromotion = res.filter(x => x.open === 1);
    //       var bonus = JSON.parse(localStorage.getItem("bonus"));
    //       var bonus_notice = false;

    //       if (bonusPromotion.length > 0) {
    //         if (localStorage.getItem("bonus") !== null) {
    //           bonus_notice = bonus.bonus_notice;

    //           if (bonusPromotion.length > bonus.bonus_list.length) {
    //             bonus_notice = true;
    //           }
    //         } else {
    //           bonus_notice = true;
    //         }
    //       }

    //       localStorage.setItem('bonus', JSON.stringify({
    //         bonus_notice: bonus_notice,
    //         bonus_list: bonusPromotion
    //       }));

    //       if (JSON.parse(localStorage.getItem('bonus')).bonus_notice == true){
    //         Swal.fire({
    //           title: '<div>' + this.svg.rewardAlertIcon + '</div>',
    //           html: '<div class="text-center font-color-6">' + this.translateService.instant('You have unclaim bonus to claim.<br> Do you want to claim it before you play?') + '</div>',
    //           footer: '<input type="checkbox" id="swal2-checkbox" value="1"> <span class="checkmark"></span>' + this.translateService.instant('Do Not Show Again'),
    //           showDenyButton: true,
    //           showCloseButton: true,
    //           showCancelButton: false,
    //           showConfirmButton: true,
    //           reverseButtons: true,
    //           denyButtonText: this.translateService.instant('SKIP'),
    //           confirmButtonText: this.translateService.instant('CLAIM NOW'),
    //           customClass: {
    //             denyButton: 'deny-button',
    //             confirmButton: 'confirm-button',
    //           }
    //         }).then(result => {
    //           if ($('#swal2-checkbox')[0].checked) {
    //             var bonus = JSON.parse(localStorage.getItem("bonus"));
    //             bonus.bonus_notice = false;
    //             localStorage.setItem("bonus",JSON.stringify(bonus));
    //           }

    //           if (result.isConfirmed) {
    //             this.router.navigateByUrl('/promotion');
    //           }
    //         });
    //       }
    //     })
    //   ).subscribe();
    // });
  }

  disconnectSocket() {
    if (this.unsubscribeBonusList) {
      this.unsubscribeBonusList();
      if (this.bonusListChannelName) {
        // this.socketIoService.leave(this.bonusListChannelName);
      }
    }
    this.unsubscribeBonusList = null;
    this.bonusListChannelName = null;
  }

}
